import { createI18n } from 'vue-i18n'
import messages from './messages.js'

const savedLocale = (typeof localStorage !== 'undefined' && localStorage.getItem('locale')) || 'zh-CN'

const i18nMessages = { ...messages, zh: messages['zh-CN'] }
;['zh-CN', 'en', 'zh'].forEach(locale => {
  const m = i18nMessages[locale] || (locale === 'zh' ? messages['zh-CN'] : null)
  if (m?.target?.report && typeof m.target.report === 'object' && !m.report) {
    m.report = m.target.report
  }
})

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: i18nMessages,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  missingWarn: false,
  fallbackWarn: false
})

export default i18n
